import "./TitleSmall.scss";
const TitleSmall = (props) => {
  return <h3 className="title--2">{props.children}</h3>;
};

export default TitleSmall;
